<template>
  <UiBaseIcon v-if="glyph" :view-box="glyph.viewBox" :width="glyph.width" :height="glyph.height" :color="resolvedColor">
    <path v-for="(path, index) in glyph.paths" :key="index" v-bind="path" />
  </UiBaseIcon>
</template>

<script lang="ts" setup>
import { UiBaseIcon } from '@experience/core-base-icon-ui';
import { computed } from 'vue';

import { iconGlyphs } from './glyphs';

export interface Props {
  /**
   * Icon name (a key from the icon glyph registry).
   */
  name: string;

  /**
   * Icon color. Pass a CSS custom property name (e.g. `--alias-color-icon-subtle`)
   * or any valid CSS color. Applies only to paths that use `currentColor`.
   */
  color?: string;
}

const props = withDefaults(defineProps<Props>(), {
  color: '--alias-color-icon-default',
});

const glyph = computed(() => iconGlyphs[props.name]);

const resolvedColor = computed(() => (props.color.startsWith('--') ? `var(${props.color})` : props.color));
</script>
